/* eslint-disable max-lines */
/* eslint-disable no-nested-ternary */
import { AppShell, Text, useMantineTheme } from '@mantine/core';
import React, { useContext, useEffect, useState } from 'react';
import NavbarLayout from '../Navbar/Navbar';
import HeaderLayout from '../Header/Header';
import IconFailed from '../../../icons/IconFailed';
import IconSuccess from '../../../icons/IconSuccess';
import Banner from '../../../elements/Banner';
import styles from './styles.scoped.css';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import IconRegistrasiPangkalan from '../../../icons/IconRegistrasiPangkalan';
import IconAturHET from '../../../icons/IconAturHET';
import IconSettingFaq from '../../../icons/IconSettingFaq';
import { getUserData } from '../../../../utils/storage';
import { fetchDetailUser, fetchSessionProtection } from '../actions';
import { router } from '../../../../utils/routeBuilder';
import { dynamicSort } from '../../../../utils/validation';
import IconManagementMerchant from '../../../icons/IconManagementMerchant';
import IconManagementUser from '../../../icons/IconManagementUser';
import IconSettingMap from '../../../icons/IconSettingMap';
import {
  AlertContext,
  AppContext,
  ModalContext,
  ToastrContext,
} from '../../../../contexts';
import { analytics } from '../../../../utils/firebase';
import { logout } from '../../../../pages/Login/actions';
import ModalLogout from '../ModalLogout';
import PropTypes from 'prop-types';
import ModalOtpVerification from '../../../fragments/ModalOtpVerification';
import { SessionExpiredContext } from '../../../../contexts/SessionExpiredContext';
import { closeModalOtp } from '../../../../contexts/sessionExpiredHelper';
import { fetchVerifyOtp } from '../../../../pages/Mfa/actions';
import ModalChangePassword from '../../../fragments/ModalChangePassword';
import { fetchChangePassword } from '../../../../pages/Profile/actions';
import { formatTime } from '../../../../utils/format';
import IconManagementSubMerchant from '../../../icons/IconManagementSubMerchant';
import { logEvent } from 'firebase/analytics';

function Base({ children }) {
  const { breadcrumbs } = useContext(AppContext);
  const theme = useMantineTheme();
  const [opened, setOpened] = useState(false);
  const [modalChangePassword, setModalChangePassword] = useState(false);
  const [interceptedMenu, setInterceptedMenu] = useState('');

  const { content, setContent } = useContext(ModalContext);
  const { alert, setAlert } = useContext(AlertContext);
  const { toastr, setToastr } = useContext(ToastrContext);
  const { setModalCtx } = useContext(ModalContext);
  const { sessionExpired } = useContext(SessionExpiredContext);

  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const { dataProductCategories, dataDetailUser } = useSelector(
    (s) => s.pageBase
  );

  const noAuthRoutes = [
    '/login',
    '/forgot-password',
    '/set-password',
    '/404',
    '/mfa/scan-qr',
    '/mfa/totp',
    '/mfa/connect-app',
    '/setup-authenticator',
  ];
  const noAuth = noAuthRoutes.some((r) => pathname.match(r));

  let navsData = [
    {
      name: 'Registrasi Pangkalan',
      to: '/registrasi-pangkalan',
      icon: <IconRegistrasiPangkalan />,
    },
    { name: 'Atur Harga Produk', to: '/price', icon: <IconAturHET /> },
    { name: 'Pengaturan FAQ', to: '/faq', icon: <IconSettingFaq /> },
    { name: 'Aktivasi Fitur MAP', to: '/activation-feature-map', icon: <IconSettingFaq /> },
    { name: 'Jenis Usaha', to: '/business-type', icon: <IconSettingFaq /> },
  ];

  const [navs, setNavs] = useState(navsData);
  const [modal, setModal] = useState(false);

  const bcs = breadcrumbs;

  const mfa = useSelector((s) => s.mfa);

  const {
    dataSubmitFaq,
    dataDeleteFaq,
    dataSubmitUpdateFaq,
    isLoadingSubmitFaq,
    isLoadingSubmitUpdateFaq,
    isLoadingDeleteFaq,
    messageReorderFaq,
    isLoadingReorderFaq,
  } = useSelector((s) => s.faq);
  const {
    dataSubmitPermission,
    dataSubmitUpdatePermission,
    isLoadingSubmitPermission,
    isLoadingSubmitUpdatePermission,
    messageSubmitPermission,
    messageSubmitUpdatePermission,
  } = useSelector((s) => s.permission);

  const {
    dataSubmitRole,
    dataSubmitUpdateRole,
    isLoadingSubmitRole,
    isLoadingSubmitUpdateRole,
    messageSubmitRole,
    messageSubmitUpdateRole,
  } = useSelector((s) => s.role);

  const { deleteNotification, orderActiveNotification } = useSelector(
    (s) => s.notification
  );

  const { isLoadingUpdateTermCondition, dataUpdateTermCondition } = useSelector(
    (s) => s.termCondition
  );

  const { isLoadingSubmitAutoApprove, dataSubmitAutoApprove } = useSelector(
    (s) => s.manualLoggingActivation
  );

  const { changePassword, countdown } = useSelector((s) => s.profile);

  const {
    isLoadingSyncUpdateStock,
    isLoadingUpdateStock,
    isLoadingUploadStock,
    messageSyncUpdateStock,
    messageUpdateStock,
    messageUploadStock,
    dataSyncUpdateStock,
    dataUploadStock,
  } = useSelector((s) => s.updateStockMerchant);

  const { isOverLimitRows } = useSelector((s) => s.merchantVerification);
  const {
    suspend,
    edit: editMerchant,
    resend,
    blockPin,
    deactivate,
    bank: bankSetting,
    sync,
  } = useSelector((state) => state.merchantSetting);

  const { download: downloadSyncMerchant } = useSelector(
    (state) => state.logsSyncMerchant
  );

  const { download, activation } = useSelector(
    (state) => state.myptmActivation
  );

  const {
    edit,
    suspend: suspendUser,
    add,
    search,
  } = useSelector((state) => state.user);

  const {
    dataSubmitAddBusinessType,
    isLoadingSubmitAddBusinessType,
    messageSubmitAddBusinessType,
    messageUpdateBusinessType,
    dataUpdateBusinessType,
    dataDeleteBusinessType,
    isLoadingUpdateBusinessType,
    isLoadingDeleteBusinessType,
  } = useSelector((state) => state.settingBusinessType);

  const {
    isLoadingUpdateSubPangkalanTermCondition,
    messageUpdateSubPangkalanTermCondition,
    dataUpdateSubPangkalanTermCondition,
  } = useSelector((s) => s.termCondition);

  const { updateNikStatus, updateNikStatusBulk } = useSelector(
    (state) => state.nikManagement
  );

  const {
    dataUpdateMerchantStatus,
    isLoadingUpdateMerchantStatus,
    dataUpdateGRMerchant,
    isLoadingUpdateGRMerchant,
  } = useSelector((state) => state.gigrActivation);

  useEffect(() => {
    if (
      dataUpdateMerchantStatus?.success &&
      !isLoadingUpdateMerchantStatus
    ) {
      setToastr({
        desc:
          dataUpdateMerchantStatus?.action === 'details'
            ? 'Status berhasil diubah'
            : 'berhasil menonaktifkan menu GI/GR Pangkalan',
        type: 'success',
        visible: true,
      });
    } else if (
      !dataUpdateMerchantStatus?.success &&
      !isLoadingUpdateMerchantStatus
    ) {
      if (dataUpdateMerchantStatus?.code === 409) {
        if (dataUpdateMerchantStatus?.status === 1) {
          setToastr({
            desc: 'Menu GI/GR Pangkalan telah aktif',
            type: 'success',
            visible: true,
          });
        } else if (dataUpdateMerchantStatus?.status === 0) {
          setToastr({
            desc: 'Menu GI/GR Pangkalan telah nonaktif',
            type: 'success',
            visible: true,
          });
        }
      } else {
        setToastr({
          desc:
            dataUpdateMerchantStatus?.message ||
            'Gagal menonaktifkan menu GI/GR Pangkalan',
          type: 'danger',
          visible: true,
        });
      }
    }
  }, [dataUpdateMerchantStatus, isLoadingUpdateMerchantStatus]);

  useEffect(() => {
    if (
      dataUpdateGRMerchant?.success &&
      !isLoadingUpdateGRMerchant
    ) {
      setToastr({
        desc: 'Berhasil sync data GR pangkalan',
        type: 'success',
        visible: true,
      });
    }

    if (
      !dataUpdateGRMerchant?.success &&
      dataUpdateGRMerchant?.code === 400 &&
      !dataUpdateGRMerchant
    ) {
      setToastr({
        desc: 'Gagal sync data GR pangkalan',
        type: 'danger',
        visible: true,
      });
    }
  }, [dataUpdateGRMerchant, isLoadingUpdateGRMerchant]);

  useEffect(() => {
    // if (
    //   !updateNikStatusBulk?.success &&
    //   !updateNikStatusBulk?.isLoading &&
    //   updateNikStatusBulk?.message &&
    //   updateNikStatusBulk?.data === null
    // ) {
    //   setToastr({
    //     desc: updateNikStatusBulk?.message || 'Gagal memperbarui status NIK',
    //     type: 'danger',
    //     visible: true,
    //   });
    // }

    if (
      updateNikStatusBulk?.success &&
      updateNikStatusBulk?.data?.failedTotal === 0 &&
      !updateNikStatusBulk?.isLoading
    ) {
      setToastr({
        desc: `Berhasil blokir ${updateNikStatusBulk?.data?.successTotal} pelanggan dalam file csv`,
        type: 'success',
        visible: true,
      });
    }

    if (updateNikStatus?.success && !updateNikStatus?.isLoading) {
      setToastr({
        desc: 'Berhasil memperbarui status NIK',
        type: 'success',
        visible: true,
      });
    } else if (!updateNikStatus?.success && !updateNikStatus?.isLoading) {
      setToastr({
        desc: updateNikStatus?.message || 'Gagal memperbarui status NIK',
        type: 'danger',
        visible: true,
      });
    }
  }, [updateNikStatus]);

  useEffect(() => {
    if (
      dataSubmitAddBusinessType &&
      !isLoadingSubmitAddBusinessType &&
      messageSubmitAddBusinessType
    ) {
      if (dataSubmitAddBusinessType.success) {
        if (dataSubmitAddBusinessType.type === '1') {
          setToastr({
            desc: `Berhasil menambahkan jenis usaha ${messageSubmitAddBusinessType}`,
            type: 'success',
            visible: true,
          });
        } else {
          const { failedTotal, successTotal } = dataSubmitAddBusinessType.data;
          if (failedTotal === 0 && successTotal > 0) {
            setToastr({
              desc: `Berhasil menambahkan ${successTotal} jenis usaha dalam file csv`,
              type: 'success',
              visible: true,
            });
          } else if (failedTotal >= 0 && successTotal === 0) {
            setToastr({
              desc: 'Tidak dapat menambahkan daftar jenis usaha, semua daftar sudah didaftarkan',
              type: 'danger',
              visible: true,
            });
          }
        }
      } else if (dataSubmitAddBusinessType.code !== 409) {
        setToastr({
          desc: messageSubmitAddBusinessType,
          type: 'danger',
          visible: dataSubmitAddBusinessType.type === '1',
        });
      }
    }
  }, [
    dataSubmitAddBusinessType,
    isLoadingSubmitAddBusinessType,
    messageSubmitAddBusinessType,
  ]);

  useEffect(() => {
    if (!isLoadingUpdateBusinessType) {
      if (dataUpdateBusinessType?.success) {
        setToastr({
          desc: (
            <Text c="#25282B" fz={16}>
              Berhasil memperbarui jenis usaha menjadi{' '}
              <b>
                {dataUpdateBusinessType.kbli} - {dataUpdateBusinessType.name}
              </b>
            </Text>
          ),
          type: 'success',
          visible: true,
        });
      } else if (dataUpdateBusinessType?.code !== 409) {
        setToastr({
          desc: messageUpdateBusinessType,
          type: 'danger',
          visible: messageUpdateBusinessType && true,
        });
      }
    }
    if (!isLoadingUpdateBusinessType) {
      if (
        Object.hasOwn(dataUpdateBusinessType || {}, 'success') &&
        !dataUpdateBusinessType?.success &&
        dataUpdateBusinessType?.code !== 409 &&
        dataUpdateBusinessType?.oldName
      ) {
        setToastr({
          desc: (
            <Text c="#25282B" fz={16}>
              Gagal memperbarui jenis usaha{' '}
              <b>{dataUpdateBusinessType.oldName}</b> menjadi{' '}
              <b>{dataUpdateBusinessType.name}</b>
            </Text>
          ),
          type: 'danger',
          visible: true,
        });
      }
    }
  }, [isLoadingUpdateBusinessType, messageUpdateBusinessType]);

  useEffect(() => {
    if (!isLoadingDeleteBusinessType && dataDeleteBusinessType?.success) {
      setToastr({
        desc: 'Berhasil menghapus jenis usaha',
        type: 'success',
        visible: true,
      });
    }
    if (
      !isLoadingDeleteBusinessType &&
      !dataDeleteBusinessType?.success &&
      Object.hasOwn(dataDeleteBusinessType || {}, 'success')
    ) {
      setToastr({
        desc: 'Gagal menghapus jenis usaha',
        type: 'danger',
        visible: true,
      });
    }
  }, [isLoadingDeleteBusinessType]);

  useEffect(() => {
    if (!edit?.loading && edit?.message) {
      setToastr({
        desc: edit.success ? (
          <span className={styles.toastrMessage}>
            {edit.actionType === 'change-role'
              ? `Berhasil merubah role user`
              : `Berhasil merubah data user`}{' '}
            <strong>{search?.data?.name}</strong>
          </span>
        ) : (
          edit.message
        ),
        type: edit.success ? 'success' : 'danger',
        visible: true,
      });
    }
  }, [edit]);

  useEffect(() => {
    if (!add?.loading && add?.message) {
      setToastr({
        desc: add.message,
        type: add.success ? 'success' : 'danger',
        visible: true,
      });
    }
  }, [add]);

  useEffect(() => {
    if (!suspendUser?.loading && suspendUser?.message) {
      setToastr({
        desc: suspendUser.message,
        type: suspendUser.success ? 'success' : 'danger',
        visible: true,
      });
    }
  }, [suspendUser]);

  useEffect(() => {
    if (!blockPin?.loading && blockPin?.message) {
      setToastr({
        desc: blockPin.message,
        type: blockPin.success ? 'success' : 'danger',
        visible: true,
      });
    }
  }, [blockPin]);

  useEffect(() => {
    if (!changePassword?.isLoading && changePassword?.message) {
      let message = changePassword?.success
        ? 'Berhasil memperbarui kata sandi. Harap masuk kembali dengan kata sandi baru.'
        : changePassword?.message;
      let type = changePassword?.success ? 'success' : 'danger';
      if (
        changePassword?.isExpired &&
        !changePassword.success &&
        changePassword.code === 400
      ) {
        message =
          'Gagal memperbarui kata sandi, kata sandi yang Anda masukkan salah.';
      } else if (changePassword?.data?.countdownTime) {
        const time = changePassword?.data?.countdownTime;
        type = 'danger';
        message = (
          <span className={styles.toastrMessage}>
            Anda telah 5 kali gagal memperbarui kata sandi, coba kembali
            setelah&nbsp; <strong>{formatTime(time)}</strong>
          </span>
        );
      }
      setToastr({
        desc: message,
        type: type,
        visible: true,
      });
      if (!changePassword?.isExpired) setModalChangePassword(false);
    }
  }, [changePassword]);

  useEffect(() => {
    if (
      !countdown?.isLoading &&
      countdown?.message &&
      countdown?.data?.countdownTime
    ) {
      let message = '';
      const time = countdown?.data?.countdownTime;
      message = (
        <span className={styles.toastrMessage}>
          Anda telah 5 kali gagal memperbarui kata sandi, coba kembali
          setelah&nbsp;
          <strong>{formatTime(time)}</strong></span>
      );

      setToastr({
        desc: message,
        type: 'danger',
        visible: true,
      });
    }
  }, [countdown]);

  useEffect(() => {
    if (downloadSyncMerchant.message && !downloadSyncMerchant.isLoading) {
      setToastr({
        desc: downloadSyncMerchant.message,
        type: downloadSyncMerchant.success ? 'success' : 'danger',
        visible: true,
      });
    }
  }, [
    downloadSyncMerchant.isLoading,
    downloadSyncMerchant.success,
    downloadSyncMerchant.message,
  ]);

  useEffect(() => {
    if (!isLoadingUpdateStock && messageUpdateStock) {
      setToastr({
        desc: messageUpdateStock,
        type: 'danger',
        visible: true,
      });
    }
  }, [isLoadingUpdateStock, messageUpdateStock]);

  useEffect(() => {
    if (!isLoadingSyncUpdateStock && dataSyncUpdateStock) {
      setToastr({
        desc: dataSyncUpdateStock?.message,
        type: dataSyncUpdateStock?.success ? 'success' : 'danger',
        visible: true,
      });
    }
  }, [isLoadingSyncUpdateStock, dataSyncUpdateStock]);

  useEffect(() => {
    if (!isLoadingSyncUpdateStock && messageSyncUpdateStock) {
      setToastr({
        desc: messageSyncUpdateStock,
        type: 'danger',
        visible: true,
      });
    }
  }, [isLoadingSyncUpdateStock, messageSyncUpdateStock]);

  useEffect(() => {
    if (!isLoadingUploadStock && messageUploadStock) {
      if (!messageUploadStock.includes('required')) {
        setToastr({
          desc: messageUploadStock,
          type: 'danger',
          visible: true,
        });
      }
    }
  }, [isLoadingUploadStock, messageUploadStock]);

  useEffect(() => {
    if (!isLoadingUploadStock && dataUploadStock?.success) {
      setToastr({
        desc: 'Berhasil mengunggah file update stok pangkalan',
        type: 'success',
        visible: true,
      });
    }
  }, [isLoadingUploadStock, messageUploadStock, dataUploadStock]);

  useEffect(() => {
    if (dataSubmitFaq && !isLoadingSubmitFaq) {
      setToastr({
        desc: 'FAQ Berhasil ditambah',
        type: 'success',
        visible: true,
      });
    }
  }, [dataSubmitFaq, isLoadingSubmitFaq]);

  useEffect(() => {
    if (messageReorderFaq && !isLoadingReorderFaq) {
      setToastr({
        desc: messageReorderFaq,
        type: 'danger',
        visible: true,
      });
    }
  }, [messageReorderFaq, isLoadingReorderFaq]);

  useEffect(() => {
    if (deleteNotification?.success && !deleteNotification?.loading) {
      setToastr({
        desc: 'Notifikasi Berhasil dihapus',
        type: 'success',
        visible: true,
      });
    } else if (
      !deleteNotification?.success &&
      !deleteNotification?.loading &&
      deleteNotification?.message
    ) {
      setToastr({
        desc: deleteNotification?.message,
        type: 'danger',
        visible: true,
      });
    }
  }, [deleteNotification]);

  useEffect(() => {
    if (dataSubmitUpdateFaq && !isLoadingSubmitUpdateFaq) {
      setToastr({
        desc: 'FAQ Berhasil diubah',
        type: 'success',
        visible: true,
      });
    }
  }, [dataSubmitUpdateFaq, isLoadingSubmitUpdateFaq]);

  useEffect(() => {
    if (dataUpdateTermCondition && !isLoadingUpdateTermCondition) {
      setToastr({
        desc: 'Syarat & Ketentuan Berhasil diubah',
        type: 'success',
        visible: true,
      });
    }
  }, [dataUpdateTermCondition, isLoadingUpdateTermCondition]);

  useEffect(() => {
    if (!isLoadingUpdateSubPangkalanTermCondition) {
      const category = 'Syarat & Ketentuan';

      if (dataUpdateSubPangkalanTermCondition?.success) {
        setToastr({
          desc: `${category} berhasil diubah`,
          type: 'success',
          visible: true,
        });
      } else if (messageUpdateSubPangkalanTermCondition) {
        const isVersionConflict =
          dataUpdateSubPangkalanTermCondition?.code === 409 ||
          (messageUpdateSubPangkalanTermCondition.includes('Version') &&
            messageUpdateSubPangkalanTermCondition.includes('sama'));

        setToastr({
          desc: isVersionConflict
            ? 'Versi tidak boleh sama dengan versi sebelumnya'
            : messageUpdateSubPangkalanTermCondition,
          type: 'danger',
          visible: true,
        });
      }
    }
  }, [
    isLoadingUpdateSubPangkalanTermCondition,
    dataUpdateSubPangkalanTermCondition,
    messageUpdateSubPangkalanTermCondition,
  ]);

  useEffect(() => {
    if (dataDeleteFaq && !isLoadingDeleteFaq) {
      setToastr({
        desc: 'FAQ Berhasil dihapus',
        type: 'success',
        visible: true,
      });
    }
  }, [dataDeleteFaq, isLoadingDeleteFaq]);

  useEffect(() => {
    if (dataSubmitPermission && !isLoadingSubmitPermission) {
      setToastr({
        desc: (
          <>
            <span className={styles.toastrMessage}>
              Berhasil menambahkan Permission{' '}
            </span>{' '}
            <b>{messageSubmitPermission}</b>
          </>
        ),
        type: 'success',
        visible: true,
      });
    }
  }, [dataSubmitPermission, isLoadingSubmitPermission]);

  useEffect(() => {
    if (dataSubmitUpdatePermission && !isLoadingSubmitUpdatePermission) {
      setToastr({
        desc: (
          <>
            <span className={styles.toastrMessage}>
              Berhasil mengubah Permission{' '}
            </span>{' '}
            <b>{messageSubmitUpdatePermission}</b>
          </>
        ),
        type: 'success',
        visible: true,
      });
    }
  }, [dataSubmitUpdatePermission, isLoadingSubmitUpdatePermission]);

  useEffect(() => {
    if (dataSubmitRole && !isLoadingSubmitRole) {
      setToastr({
        desc: (
          <>
            <span className={styles.toastrMessage}>
              Berhasil menambahkan Role{' '}
            </span>{' '}
            <b>{messageSubmitRole}</b>
          </>
        ),
        type: 'success',
        visible: true,
      });
    }
  }, [dataSubmitRole, isLoadingSubmitRole]);

  useEffect(() => {
    if (dataSubmitUpdateRole && !isLoadingSubmitUpdateRole) {
      setToastr({
        desc: (
          <>
            <span className={styles.toastrMessage}>
              Berhasil mengubah Role{' '}
            </span>{' '}
            <b>{messageSubmitUpdateRole}</b>
          </>
        ),
        type: 'success',
        visible: true,
      });
    }
  }, [dataSubmitUpdateRole, isLoadingSubmitUpdateRole]);

  useEffect(() => {
    if (dataSubmitAutoApprove && !isLoadingSubmitAutoApprove) {
      setToastr({
        desc:
          dataSubmitAutoApprove === 'all' ? (
            <>
              <span className={styles.toastrMessage}>
                Berhasil mengubah pengaturan sekaligus
              </span>
            </>
          ) : (
            <>
              <span className={styles.toastrMessage}>
                Berhasil mengubah pengaturan untuk Kelurahan
              </span>{' '}
              <b>{dataSubmitAutoApprove}</b>
            </>
          ),
        type: 'success',
        visible: true,
      });
    }
  }, [isLoadingSubmitAutoApprove, dataSubmitAutoApprove]);

  useEffect(() => {
    if (
      !dataSubmitPermission &&
      messageSubmitPermission &&
      !isLoadingSubmitPermission
    ) {
      setToastr({
        desc: messageSubmitPermission,
        type: 'danger',
        visible: true,
      });
    }
  }, [isLoadingSubmitPermission]);

  useEffect(() => {
    if (!dataSubmitRole && messageSubmitRole && !isLoadingSubmitRole) {
      setToastr({
        desc: messageSubmitRole,
        type: 'danger',
        visible: true,
      });
    }
  }, [isLoadingSubmitRole]);

  useEffect(() => {
    if (isOverLimitRows.showAlert && isOverLimitRows.rowsSelected > 20) {
      setToastr({
        desc: (
          <>
            <span className={styles.dangerToastr}>
              Batas maksimal yang dapat dipilih hanya <b>20</b> pangkalan LPG 3
              kg
            </span>
          </>
        ),
        type: 'danger',
        visible: true,
      });
    }
  }, [isOverLimitRows]);

  useEffect(() => {
    if (suspend.message) {
      setToastr({
        desc: suspend.message,
        type: suspend.success ? 'success' : 'danger',
        visible: true,
      });
    }
  }, [suspend.success, suspend.message]);

  useEffect(() => {
    if (resend.message && resend?.error?.code !== 429) {
      setToastr({
        desc: resend.message,
        type: resend.success ? 'success' : 'danger',
        visible: true,
      });
    }
  }, [resend.success, resend.message]);

  useEffect(() => {
    if (bankSetting.message) {
      setToastr({
        desc: bankSetting.message,
        type: bankSetting.success ? 'success' : 'danger',
        visible: true,
      });
    }
  }, [bankSetting.success, bankSetting.message]);

  useEffect(() => {
    if (editMerchant.message) {
      setToastr({
        desc: editMerchant.message,
        type: editMerchant.success ? 'success' : 'danger',
        visible: true,
      });
    }
  }, [editMerchant.success, editMerchant.message]);

  useEffect(() => {
    if (deactivate.message) {
      setToastr({
        desc: deactivate.message,
        type: deactivate.success ? 'success' : 'danger',
        visible: true,
      });
    }
  }, [deactivate.success, deactivate.message]);

  useEffect(() => {
    if (!sync.loading && sync.success) {
      setToastr({
        visible: true,
        desc: 'Berhasil sinkronisasi data dengan Monica',
        type: 'success',
      });
    }
    if (
      !sync.loading &&
      !sync.success &&
      sync.message &&
      !sync.message.includes('Terjadi kesalahan')
    ) {
      setModalCtx({ name: 'sync', opened: true, data: sync.data });
    }

    if (
      !sync.loading &&
      !sync.success &&
      sync.message.includes('Terjadi kesalahan')
    ) {
      setToastr({
        visible: true,
        desc: sync.message,
        type: 'danger',
      });
    }
  }, [sync]);

  useEffect(() => {
    if (download.message) {
      setToastr({
        desc: download.message,
        type: download.toastrType,
        visible: true,
      });
    }
  }, [download.success, download.message, download.toastrType]);

  useEffect(() => {
    if (activation.message) {
      setToastr({
        desc: activation.message,
        type: activation.toastrType,
        visible: true,
      });
    }
  }, [activation.success, activation.message, activation.toastrType]);

  useEffect(() => {
    if (!orderActiveNotification?.success && orderActiveNotification?.message) {
      setToastr({
        desc: orderActiveNotification.message,
        type: 'danger',
        visible: true,
      });
    }
  }, [orderActiveNotification]);

  useEffect(() => {
    const body = document.getElementsByTagName('body')[0];
    body.style.backgroundColor = noAuthRoutes.includes(pathname)
      ? '#FFFFFF'
      : '#F5F6FA';
  }, [pathname]);

  useEffect(() => {
    if (!noAuth) {
      const app = document.getElementById('app');
      app.className = 'pagebase';
    }
  }, []);

  useEffect(() => {
    if (getUserData()?.adminId) {
      dispatch(fetchDetailUser());
    }
  }, []);

  const filterItems = (arr, query) => {
    return arr?.filter((el) => el?.type === query);
  };

  useEffect(() => {
    const permission = dataDetailUser?.permitions?.map((object) => {
      const icon = router.find((route) => route.path === object.path)?.icon;
      const type = router.find((route) => route.path === object.path)?.menu;
      const serialNumber = router.find(
        (route) => route.path === object.path
      )?.serialNumber;

      const menu = {
        name: object.name,
        to: object.path,
        icon: icon,
        type,
        serialNumber,
      };
      return menu;
    });

    const childrenMenuMerchantManagement = filterItems(
      permission,
      'merchant-management'
    );
    const childrenMenuSubMerchantManagement = filterItems(
      permission,
      'sub-merchant-management'
    );
    const childrenMenuUserManagement = filterItems(
      permission,
      'user-management'
    );
    const childrenMenuSettingMap = filterItems(permission, 'setting-map');
    const childrenMenuCustomerManagement = filterItems(
      permission,
      'customer-setting'
    );

    const merchantManagement =
      childrenMenuMerchantManagement.length > 0
        ? [
          {
            name: 'Manajemen Pangkalan LPG 3 Kg',
            child: childrenMenuMerchantManagement.sort(
              dynamicSort('serialNumber')
            ),
            icon: <IconManagementMerchant />,
            show: pathname.includes('/merchant/'),
            onClick: () => {
              setInterceptedMenu('Manajemen Pangkalan LPG 3 Kg');
              dispatch(fetchSessionProtection());
            },
          },
        ]
        : [];
    const customerManagement =
      childrenMenuCustomerManagement.length > 0
        ? [
          {
            name: 'Manajemen Pelanggan',
            child: childrenMenuCustomerManagement.sort(
              dynamicSort('serialNumber')
            ),
            icon: <IconManagementSubMerchant />,
            show:
              pathname.includes('/customer-setting') ||
              pathname.includes('/province-transaction-restriction'),
            onClick: () => {
              setInterceptedMenu('Manajemen Pelanggan');
              dispatch(fetchSessionProtection());
            },
          },
        ]
        : [];

    const subMerchantMangement =
      childrenMenuSubMerchantManagement.length > 0
        ? [
          {
            name: 'Manajemen Subpangkalan LPG 3 Kg',
            child: childrenMenuSubMerchantManagement.sort(
              dynamicSort('serialNumber')
            ),
            icon: <IconManagementSubMerchant />,
            show: pathname.includes('/sub-merchant/'),
            onClick: () => {
              setInterceptedMenu('Manajemen Subpangkalan LPG 3 Kg');
              dispatch(fetchSessionProtection());
            },
          },
        ]
        : [];

    const userManagement =
      childrenMenuUserManagement.length > 0
        ? [
          {
            name: 'Manajemen User',
            child: childrenMenuUserManagement.sort(
              dynamicSort('serialNumber')
            ),
            icon: <IconManagementUser />,
            show: pathname.includes('/user-management/'),
          },
        ]
        : [];

    const settingMap =
      childrenMenuSettingMap.length > 0
        ? [
          {
            name: 'Pengaturan MAP',
            child: childrenMenuSettingMap.sort(dynamicSort('serialNumber')),
            icon: <IconSettingMap />,
            show: pathname.includes('/merchant/'),
          },
        ]
        : [];

    const navs = [
      ...filterItems(permission, 'price'),
      ...filterItems(permission, 'subsidy-info'),
      // ...filterItems(permission, 'faq'),
      // ...filterItems(permission, 'term'),
      ...settingMap,
      ...filterItems(permission, 'activation-feature-map'),
      ...merchantManagement,
      ...subMerchantMangement,
      ...customerManagement,
      ...userManagement,
    ];
    setNavs(navs);

    if (dataDetailUser?.isPasswordExpired) {
      setModalChangePassword(true);
    }
  }, [dataProductCategories, dataDetailUser]);

  const closeModal = (e) => {
    if (e.target === e.currentTarget) {
      setContent(null);
    }
  };

  const handledClose = () => {
    window.location.replace('/dc/authentication');
    closeModalOtp();
  };

  useEffect(() => {
    const body = document.getElementsByTagName('body')[0];
    if (content) {
      body.className = 'modal-open';
    }
    if (alert) {
      body.className = 'alert-open';
    } else {
      setAlert(null);
    }
    if (!alert && !content) {
      body.className = '';
    }
  }, [content, alert]);

  const handleSubmit = (otp) => {
    dispatch(fetchVerifyOtp({ otp }));
  };

  const handleChangePassword = (val) => {
    const params = {
      currentPassword: val.password,
      newPassword: val.newPassword,
    };
    dispatch(fetchChangePassword(params, true));
  };

  const handleLogout = () => {
    logEvent(analytics, 'confirm_logout', {
      from_path: location.pathname,
    });
    dispatch(logout());
  };

  useEffect(() => {
    if (mfa.code === 200 && !mfa.isLoading) {
      // window.location.reload();
      closeModalOtp();
    }
  }, [mfa.code, mfa.isLoading]);

  if (noAuth) {
    return (
      <>
        {children}
        {toastr?.visible ? (
          <div className={styles.alert}>
            <Banner
              {...toastr}
              icon={
                toastr.type === 'success' ? (
                  <IconSuccess className={styles.icon} />
                ) : (
                  <IconFailed />
                )
              }
            />
          </div>
        ) : null}
        <div className={styles.modal} onClick={closeModal}>
          {content}
        </div>
      </>
    );
  }

  return (
    <AppShell
      header={{ height: 116 }}
      layout="alt"
      navbar={{
        width: 300,
        breakpoint: 'sm',
        collapsed: { mobile: !opened, desktop: false },
      }}
      padding="md"
      styles={{
        main: {
          overflowY: 'auto',
        },
      }}
    >
      <AppShell.Header>
        <HeaderLayout
          bcs={bcs}
          dataDetailUser={dataDetailUser}
          opened={opened}
          pathname={pathname}
          setModal={setModal}
          setOpened={setOpened}
          theme={theme}
          toastr={toastr}
        />
      </AppShell.Header>
      <AppShell.Navbar>
        <NavbarLayout
          navs={navs}
          opened={opened}
          setOpened={setOpened}
          theme={theme}
        />
      </AppShell.Navbar>
      <AppShell.Main>
        <div className={styles.children} id="children-container">
          {children}
        </div>
        <div className={styles.modal} onClick={closeModal}>
          {content}
        </div>
        <ModalLogout
          onClick={handleLogout}
          onClose={() => {
            logEvent(analytics, 'cancel_logout', {
              to_path: location.pathname,
            });
            setModal(false);
          }}
          open={modal}
        />
        <ModalOtpVerification
          handledClose={handledClose}
          handleSubmit={handleSubmit}
          open={sessionExpired}
          targetMenu={interceptedMenu}
        />
        <ModalChangePassword
          closeBtn={{ style: 'light-danger', text: 'Keluar (Logout)' }}
          handleClose={handleLogout}
          handleSubmit={(val) => handleChangePassword(val)}
          isLoading={changePassword?.isLoading}
          open={modalChangePassword}
          subtitle="Anda perlu memperbarui kata sandi berkala tiap 3 bulan. Harap perbarui kata sandi Anda untuk dapat melanjutkan akses Dashboard Console Subsidi Tepat."
          title="Perbarui Kata Sandi Sekarang"
          withCloseButton={false}
        />
      </AppShell.Main>
    </AppShell>
  );
}

export default Base;

Base.propTypes = {
  children: PropTypes.node,
};
